
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"56","height":"44","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".75","y":".5","width":"54","height":"43","rx":"4.5","fill":"#fff","stroke":"#CED4DA"}}),_c('path',{attrs:{"d":"M27.25 12a10 10 0 017.566 16.538l-3.783-3.269A5 5 0 0027.25 17v-5z","fill":"#000"}}),_c('path',{attrs:{"d":"M34.853 28.495A10 10 0 1127.263 12l-.007 5a5 5 0 103.796 8.248l3.801 3.247z","fill":"#000"}}),_c('path',{attrs:{"stroke":"#fff","stroke-width":"2","d":"M27.246 17.504v-5.668M30.923 24.826l4.535 3.645"}})])
          )
        }
      }
    